import { Navigate } from "react-router-dom";
import { ProtectedRoute, TranslationBreadcrumb } from "components/UI";
import {
  CompanyProfile,
  RecruitmentManagement,
  RecruitmentJob,
  RecruitmentCandidate,
  ContentRecruitmentJob,
  ContentRecruitmentManagement,
  ContentDetailJob,
  ContentDetailCandidate,
  ContentSendMessageCandidate,
  ContentActivityCandidate,
  AddRecruitmentJob,
  AddRecruitmentCandidate,
  EditRecruitmentJobDescription,
  EditRecruitmentJobRegistration,
  EditRecruitmentJobStages,
  EditCompanyProfile,
  AddRecruitmentTemplate,
  EditRecruitmentTemplate,
  DeleteRecruitmentTemplate,
  DeleteRecruitmentStage,
  DeleteNoteCandidate,
  DeleteCandidate,
  AddRecruitmentStage,
  AddRecruitmentJobDescription,
  AddRecruitmentJobRegistration,
  AddRecruitmentJobStages,
  ContentCandidateJob,
  ContentEditJob,
  ContentNoteCandidate,
  AddNoteCandidate,
  EditNoteCandidate,
  ImportRecruitmentCandidate,
  RejectCandidate,
  EditRecruitmentStage,
  ContentRecruitmentBroadcast,
  DetailRecruitmentJob,
  EditCandidate,
  DetailRecruitmentCandidate,
} from "./pages";

const recruitmentRoutes = [
  {
    path: "/recruitment",
    element: (
      <ProtectedRoute name="recruitment">
        <Navigate to="profile" replace />
      </ProtectedRoute>
    ),
    breadcrumb: () => (
      <TranslationBreadcrumb
        name="recruitment"
        defaultTitle="recruitment.title"
      />
    ),
  },
  {
    path: "/recruitment/job",
    element: (
      <ProtectedRoute name="recruitment_job">
        <Navigate to="published" replace />
      </ProtectedRoute>
    ),
    breadcrumb: () => (
      <TranslationBreadcrumb name="recruitment.job_vacancies" />
    ),
  },
  {
    path: "/recruitment/profile",
    element: (
      <ProtectedRoute name="recruitment_profile">
        <CompanyProfile />
      </ProtectedRoute>
    ),
    breadcrumb: () => (
      <TranslationBreadcrumb
        name="recruitment_profile"
        defaultTitle="recruitment.company_profile_title"
      />
    ),
  },
  {
    path: "/recruitment/profile/add",
    element: (
      <ProtectedRoute name="recruitment_profile">
        <EditCompanyProfile type="add" />
      </ProtectedRoute>
    ),
    breadcrumb: () => (
      <TranslationBreadcrumb name={"recruitment.add_company_profile"} />
    ),
  },
  {
    path: "/recruitment/profile/edit",
    element: (
      <ProtectedRoute name="recruitment_profile">
        <EditCompanyProfile type="edit" />
      </ProtectedRoute>
    ),
    breadcrumb: () => (
      <TranslationBreadcrumb name={"recruitment.edit_company_profile"} />
    ),
  },
  {
    path: "/recruitment/management",
    element: (
      <ProtectedRoute name="recruitment_management">
        <RecruitmentManagement />
      </ProtectedRoute>
    ),
    breadcrumb: () => (
      <TranslationBreadcrumb
        name="recruitment_management"
        defaultTitle="recruitmentManagement.title"
      />
    ),
    children: [
      {
        path: "/recruitment/management/stages",
        element: <ContentRecruitmentManagement type="stages" />,
        breadcrumb: null,
        children: [
          {
            path: "/recruitment/management/stages/add",
            element: <AddRecruitmentStage type="stages" />,
            breadcrumb: null,
          },
          {
            path: "/recruitment/management/stages/edit/:id",
            element: <EditRecruitmentStage type="stages" />,
            breadcrumb: null,
          },
          {
            path: "/recruitment/management/stages/delete/:stageId",
            element: <DeleteRecruitmentStage type="stages" />,
            breadcrumb: null,
          },
        ],
      },
      {
        path: "/recruitment/management/templates",
        element: <ContentRecruitmentManagement type="templates" />,
        breadcrumb: null,
        children: [
          {
            path: "/recruitment/management/templates/delete/:stageId",
            element: <DeleteRecruitmentTemplate type="templates" />,
            breadcrumb: null,
          },
        ],
      },
      {
        path: "/recruitment/management/broadcast",
        element: <ContentRecruitmentBroadcast type="broadcast" />,
        breadcrumb: null,
      },
    ],
  },
  {
    path: "/recruitment/management/templates/add",
    element: (
      <ProtectedRoute name="recruitment_management">
        <AddRecruitmentTemplate type="templates" />
      </ProtectedRoute>
    ),
    breadcrumb: () => (
      <TranslationBreadcrumb
        name={"recruitmentManagement.add_recruitment_template"}
      />
    ),
  },
  {
    path: "/recruitment/management/templates/edit/:id",
    element: (
      <ProtectedRoute name="recruitment_management">
        <EditRecruitmentTemplate type="templates" />
      </ProtectedRoute>
    ),
    breadcrumb: () => (
      <TranslationBreadcrumb
        name={"recruitmentManagement.edit_recruitment_template"}
      />
    ),
    children: [
      {
        path: "/recruitment/management/templates/edit/:id/delete",
        element: <DeleteRecruitmentTemplate type="templates" />,
        breadcrumb: null,
      },
    ],
  },
  {
    path: "/recruitment/job",
    element: (
      <ProtectedRoute name="recruitment_job">
        <RecruitmentJob />
      </ProtectedRoute>
    ),
    breadcrumb: () => (
      <TranslationBreadcrumb
        name="recruitment_job"
        defaultTitle="recruitmentJob.title"
      />
    ),
    children: [
      {
        path: "/recruitment/job/published",
        element: <ContentRecruitmentJob type="published" />,
        breadcrumb: null,
      },
      {
        path: "/recruitment/job/closed",
        element: <ContentRecruitmentJob type="closed" />,
        breadcrumb: null,
      },
      {
        path: "/recruitment/job/draft",
        element: <ContentRecruitmentJob type="draft" />,
        breadcrumb: null,
      },
    ],
  },
  {
    path: "/recruitment/job/add",
    element: (
      <ProtectedRoute name="recruitment_job">
        <AddRecruitmentJob />
      </ProtectedRoute>
    ),
    breadcrumb: () => (
      <TranslationBreadcrumb name={"recruitmentJob.add_job_vacancy"} />
    ),
    children: [
      {
        path: "/recruitment/job/add/description",
        element: <AddRecruitmentJobDescription />,
        breadcrumb: null,
      },
      {
        path: "/recruitment/job/add/registration/:id",
        element: <AddRecruitmentJobRegistration />,
        breadcrumb: null,
      },
      {
        path: "/recruitment/job/add/stages/:id",
        element: <AddRecruitmentJobStages />,
        breadcrumb: null,
      },
    ],
  },
  {
    path: "/recruitment/job/:id",
    element: (
      <ProtectedRoute name="recruitment_job">
        <DetailRecruitmentJob />
      </ProtectedRoute>
    ),
    breadcrumb: () => (
      <TranslationBreadcrumb name={"recruitmentJob.detail_job"} />
    ),
    children: [
      {
        path: "/recruitment/job/:id/detail",
        element: <ContentDetailJob />,
        breadcrumb: null,
      },
      {
        path: "/recruitment/job/:id/candidate",
        element: <ContentCandidateJob />,
        breadcrumb: null,
        children: [
          {
            path: "/recruitment/job/:id/candidate/:candidateId/note",
            element: <AddNoteCandidate />,
            breadcrumb: null,
          },
          {
            path: "/recruitment/job/:id/candidate/:candidateId/reject",
            element: <RejectCandidate />,
            breadcrumb: null,
          },
        ],
      },
      {
        path: "/recruitment/job/:id/edit",
        element: <ContentEditJob />,
        breadcrumb: null,
        children: [
          {
            path: "/recruitment/job/:id/edit/description",
            element: <EditRecruitmentJobDescription />,
            breadcrumb: null,
          },
          {
            path: "/recruitment/job/:id/edit/registration",
            element: <EditRecruitmentJobRegistration />,
            breadcrumb: null,
          },
          {
            path: "/recruitment/job/:id/edit/stages",
            element: <EditRecruitmentJobStages />,
            breadcrumb: null,
          },
        ],
      },
    ],
  },
  {
    path: "/recruitment/candidate",
    element: (
      <ProtectedRoute name="recruitment_candidate">
        <RecruitmentCandidate />
      </ProtectedRoute>
    ),
    breadcrumb: () => (
      <TranslationBreadcrumb
        name="recruitment_candidate"
        defaultTitle="recruitmentCandidate.title"
      />
    ),
    children: [
      {
        path: "/recruitment/candidate/import",
        element: <ImportRecruitmentCandidate />,
        breadcrumb: null,
      },
    ],
  },
  {
    path: "/recruitment/candidate/add",
    element: (
      <ProtectedRoute name="recruitment_candidate">
        <AddRecruitmentCandidate />
      </ProtectedRoute>
    ),
    breadcrumb: () => (
      <TranslationBreadcrumb name={"recruitmentCandidate.add_candidate"} />
    ),
  },
  {
    path: "/recruitment/candidate/:id/edit",
    element: (
      <ProtectedRoute name="recruitment_candidate">
        <EditCandidate />
      </ProtectedRoute>
    ),
    breadcrumb: null,
  },
  {
    path: "/recruitment/candidate/:id",
    element: (
      <ProtectedRoute name="recruitment_candidate">
        <DetailRecruitmentCandidate />
      </ProtectedRoute>
    ),
    breadcrumb: () => (
      <TranslationBreadcrumb name={"recruitmentCandidate.candidate_detail"} />
    ),
    children: [
      {
        path: "/recruitment/candidate/:id/detail",
        element: <ContentDetailCandidate />,
        breadcrumb: null,
      },
      {
        path: "/recruitment/candidate/:id/send-message",
        element: <ContentSendMessageCandidate />,
        breadcrumb: null,
      },
      {
        path: "/recruitment/candidate/:id/note",
        element: <ContentNoteCandidate />,
        breadcrumb: null,
        children: [
          {
            path: "/recruitment/candidate/:id/note/add/",
            element: <AddNoteCandidate />,
            breadcrumb: null,
          },
          {
            path: "/recruitment/candidate/:id/note/edit/:noteId",
            element: <EditNoteCandidate />,
            breadcrumb: null,
          },
          {
            path: "/recruitment/candidate/:id/note/delete/:noteId",
            element: <DeleteNoteCandidate type="note" />,
            breadcrumb: null,
          },
        ],
      },
      {
        path: "/recruitment/candidate/:id/activity-history",
        element: <ContentActivityCandidate />,
        breadcrumb: null,
      },
      {
        path: "/recruitment/candidate/:id/delete",
        element: <DeleteCandidate type="candidate" />,
        breadcrumb: null,
      },
    ],
  },
];

export default recruitmentRoutes;
